import React, { useState, useEffect } from "react";
import Loading from "../components/layouts/Loading/Loading";
import { Helmet } from "react-helmet";
import PlanView from "@fitpeo/fit-plan-viewer";
import { TempAxiosGet } from "../utils/TokenStorage";
import { Typography } from "antd"
import { getDateOfService } from "../utils/getDateOfService";

const MobileRPM = () => {
  const [patientInfo, setPatientInfo] = useState(null)
  const [treatmentPlanData, setTreatmentPlanData] = useState(null)
  const [providers, setProviders] = useState(null)
  const [practitioners, setPractitioners] = useState(null)
  const [icdCodes, setIcdCodes] = useState(null)
  const [loading, setLoading] = useState(true)
  const [firstCall, setFirstCall] = useState(false)
  const [planDate, setplanDate] = useState()
  const [addedBy, setAddedBy] = useState();

  // useEffect(() => {
  //     const timer = setTimeout(() => {
  //         if (window.value !== undefined && window.token !== undefined && firstCall === false) {
  //             getPatientData(window.value.patientId)
  //             getRpmPlan(window.value.patientId)
  //             setFirstCall(true)
  //     }
  //     }, 1000);
  //     return () => clearTimeout(timer);

  // }, [window.value]);

  useEffect(() => {
    setTimeout(() => {
      if (window.value !== undefined && window.token !== undefined && firstCall === false) {
        getPatientData(window.value.patientId)
        setFirstCall(true)
      }
    }, 1000)
  }, [window.token]) //eslint-disable-line

  const getRpmPlan = async patientID => {
    const res = await TempAxiosGet(
      window.token,
      `/api/rpm/readings/treatmentplan/latest/${patientID}/fetch`
    )
    if (res?.details) {
      setplanDate(res?.details?.planDate.slice(0, 10))
      setAddedBy(res?.details?.plan?.addingBy);
      setTreatmentPlanData(Object.values(res?.details?.plan))
    }
  }

  const getProvider = async patientID => {
    const res = await TempAxiosGet(window.token, `/api/cs/patients/monitoring/${patientID}/fetch`)
    if (res?.details?.rpm) {
      let providers = []
      let practitioners = []
      res?.details?.rpm?.map(item => {
        if (item.providerId) {
          providers.push(`${item?.providerfirstName}${(item?.providerMiddleName && item?.providerMiddleName !== "") ? " " + item?.providerMiddleName : ""} ${item?.providerLastName}`)
        }
        if (item.practitionerId) {
          practitioners.push(`${item?.practitionerfirstName}${(item?.practitionerMiddleName && item?.practitionerMiddleName !== "") ? " " + item?.practitionerMiddleName : ""} ${item?.practitionerLastName}`)
        }
      })
      setProviders(providers)
      setPractitioners(practitioners)
    }
  }

  const getIcds = async patientID => {
    const res = await TempAxiosGet(window.token, `/api/cs/patients/diagnostic/${patientID}/fetch`)
    setIcdCodes(res?.details?.map(({ icdCode }) => icdCode))
  }

  const getPatientData = async patientId => {
    const res = await TempAxiosGet(window.token, `/api/cs/patients/${patientId}/profile`);
    if (res !== undefined) {
      setPatientInfo(res?.details)
      await getRpmPlan(patientId)
      await getProvider(patientId)
      await getIcds(patientId)
      setLoading(false)
    }
  }

  return (
    <>
      <Helmet>
        <script>{`
                function fillDetails(jsonData) {
                var content = JSON.parse(decodeURIComponent(jsonData))
                // var content = {"token":"eyJhbGciOiJSUzI1NiJ9.eyJpc3MiOiJzZWxmIiwic3ViIjoiNDMzOTYwOWMtN2M1MC00YTgyLWI2MTctYzBkOGRmZjc3NGVlIiwiZXhwIjoxNzE3NDA2NTAxLCJpYXQiOjE3MTc0MDI5MDEsInNjb3BlIjoiY2FyZXRha2VyX2FsbCJ9.seEg43quzF0JuXOST1SxSk3pdsL1V_u3Iwo1LSJzhBE6deP3SfXcxivchc_q5BDrLLcvKOIQCLfKl7qm6p2PsMKUWhoRW34M5SMAhvi1yFxii6QH0xyA5ZfjTwOEGYMgORcV9kL3zAu2c-WzQHxgHGv5EEcGK9Ch-j81U8sAgo4w3gbC7C0lq2mP_5lvIrh7-bVY6qeeTmCZDIOpPDTx_Vh2vEoNS9-LN33MbyYLFnmUXlJ95JktVAACLRGpMjqpDZjetaV-_KreWir6z2mytk0WSiOBLWTsFpYYQcsR5mSwoZvUqI06DJJdDWjtKbrRpZiizVm-63YM8_UU58nzPw", patientId:"89c1328f-1b76-4622-b03b-cd61d5f441ae"};
                
                window.isMobileVersion = true;
                window.value = content;
                window.token = content.token; 
                
        }`}</script>
      </Helmet>
      {loading ? (
        <Loading />
      ) : (
        (patientInfo !== undefined && treatmentPlanData && (
          <PlanView
            type="rpm"
            patientInfoDetail={patientInfo}
            plan={treatmentPlanData?.filter(data => data.id)}
            planDate={planDate}
            planIcds={icdCodes}
            addedBy={addedBy}
            providers={providers}
            practitioners={practitioners}
            serviceDate={getDateOfService(planDate)}
          />
        )) || (
          <Typography.Title level={4} className="mt-3 text-center">
            No plan found
          </Typography.Title>
        ))
      }
    </>
  )
}

export default MobileRPM
